import { render, staticRenderFns } from "./ProposalPriceAndTerms.vue?vue&type=template&id=a7c8bd0c&"
import script from "./ProposalPriceAndTerms.vue?vue&type=script&lang=js&"
export * from "./ProposalPriceAndTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports